import {
  AdminUserResult,
  AdminUsersResult
} from "@futuri/cloudsso-client/src/client/types/admin";
import { LoginResult } from "@futuri/cloudsso-client/src/client/types/api";
import { Module } from "vuex";
import { fetchAdminUsers, setCurrentUserEmail, closeUserEdit } from "./actions";
import { SET_ADMIN_USERS_RESULT, SET_CURRENT_USER_EMAIL } from "./mutations";

export interface AdminModuleState {
  usersResult?: AdminUsersResult;
  currentUserEmail?: string;
  currentUser?: AdminUserResult;
}

const adminModule: Module<AdminModuleState, any> = {
  namespaced: true,
  getters: {
    allUsers: state => state.usersResult?.data ?? [],

    isEditingUser: state => !!state.currentUserEmail,

    currentUserEmail: state => state.currentUserEmail,

    currentUser: (
      state,
      _rootState: any,
      rootGetters: any
    ): AdminUserResult | undefined => {
      const email = state.currentUserEmail;
      // const users = (state.usersResult?.data ?? [])
      const users = (rootGetters.portalData as LoginResult)?.users ?? [];

      return users.find(u => u.email === email);
    }
  },

  actions: {
    fetchAdminUsers,
    setCurrentUserEmail,
    closeUserEdit
  },
  mutations: {
    SET_ADMIN_USERS_RESULT,
    SET_CURRENT_USER_EMAIL
  },
  state: {
    usersResult: undefined,
    currentUserEmail: undefined
  }
};

export default adminModule;
